import React from 'react';
import { SparklesIcon, ChevronRightIcon } from './Icons';

export const SaaSCallToAction: React.FC = () => {
    return (
        <div className="my-12 p-8 bg-gradient-to-br from-brand-text-title to-slate-800 rounded-3xl text-white shadow-xl relative overflow-hidden group">
            <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
                <div className="max-w-md text-center md:text-left">
                    <div className="inline-flex items-center gap-2 px-3 py-1 bg-brand-pink/20 text-brand-pink rounded-full text-xs font-bold mb-4">
                        <SparklesIcon className="w-3 h-3" />
                        <span>FOR SERIOUS BAKERS</span>
                    </div>
                    <h3 className="text-2xl md:text-3xl font-serif font-bold mb-4 leading-tight">
                        Turn Your Passion into a <span className="text-brand-pink">Bakery Pro</span> Business
                    </h3>
                    <p className="text-white/70 text-sm md:text-base mb-0 leading-relaxed">
                        Join 500+ home bakers who use our software to automate pricing, manage orders, and grow their profits.
                    </p>
                </div>
                <div className="flex-shrink-0">
                    <a 
                        href="/saas" 
                        className="inline-flex items-center gap-3 px-8 py-4 bg-brand-pink !text-white rounded-2xl font-bold shadow-lg shadow-brand-pink/20 hover:scale-105 transition-all group"
                    >
                        <span>Learn More About Bakery Pro</span>
                        <ChevronRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                    </a>
                </div>
            </div>
            {/* Subtle patterns */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-pink/10 rounded-full -mr-16 -mt-16 blur-3xl group-hover:bg-brand-pink/20 transition-colors" />
            <div className="absolute bottom-0 left-0 w-32 h-32 bg-white/5 rounded-full -ml-16 -mb-16 blur-3xl" />
        </div>
    );
};
